export const COMMITTED_INTEREST_GROUP_FIELD = "COMMITTED_INTEREST_GROUP";
export const SELECTED_INTEREST_GROUP_FIELD = "SELECTED_INTEREST_GROUP";

export const enum CommitmentOptions {
    Commited = "Commited",
    DropIn = "DropIn",
}
